import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

// Controls
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

// Material
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSelectModule } from "@angular/material/select";

// Components
import { AppComponent } from './app.component';
import { FileSelectorComponent } from "./components/file-selector/file-selector.component";
import { OrgDepDivSelectorComponent } from "./components/org-dep-div-selector/org-dep-div-selector.component";
import { CheckBoxListComponent } from "./components/check-box-list/check-box-list.component";
import { OfferMembersComponent } from "./components/offer-members/offer-members.component";

// Sections
import { HeaderComponent } from './sections/header/header.component';

// Pages
import { OfferListComponent } from './pages/offer-list/offer-list.component';
import { OfferComponent } from './pages/offer/offer.component';
import { OperationListComponent } from './pages/operation-list/operation-list.component';
import { AddOfferComponent } from './pages/add-offer/add-offer.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

// Modules
import { SectionsModule } from './sections/sections.module';

// Routing
import { routing } from './app.routing';

// Resolvers
import { OfferListResolve } from './pages/offer-list/offer-list.resolve';
import { OfferResolve } from './pages/offer/offer.resolve';
import { OperationListResolve } from './pages/operation-list/operation-list.resolve';
import { OffersCountResolve } from './pages/offer-list/offers-count.resolve';
import { OperationCountResolve } from './pages/operation-list/operation-count.resolve';
import { ChipsCountResolve } from './resolvers/chips-count.resolve';
import { AddOfferResolve } from './pages/add-offer/add-offer.resolve';
import { ActivityCountResolve } from "./resolvers/activity-count.resolve";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    OfferListComponent,
    OfferComponent,
    OperationListComponent,
    AddOfferComponent,
    NotFoundComponent,
    FileSelectorComponent,
    OrgDepDivSelectorComponent,
    CheckBoxListComponent,
    OfferMembersComponent
  ],
  imports: [
    NgbModule,
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),

    FormsModule,
    ReactiveFormsModule,
    SectionsModule,
    NgSelectModule,

    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatDialogModule,
    MatMenuModule,

    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatSelectModule,

    routing
  ],
  providers: [
    OfferListResolve,
    OfferResolve,
    AddOfferResolve,
    OperationListResolve,
    ChipsCountResolve,
    OffersCountResolve,
    ActivityCountResolve,
    OperationCountResolve,
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'ru'
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['l', 'LL'],
        },
        display: {
          monthYearLabel: 'MMM YYYY',
          dateInput: 'DD.MM.YYYY',
        },
      },
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {
        useUtc: true
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locale/', '.json');
}

